import { accionRecortadaEnObra } from 'src/utils/permisos/accionesPorProyecto';

const DECISIONES = ['desimputar', 'anular'];

// Mismo criterio que Caja (cajas.js, D14): obra no cerrada y GESTIONAR_MOVIMIENTO no recortado en la obra.
export const puedeEliminarMovimiento = (user, movimiento, idsObrasCerradas = new Set()) => (
  Boolean(movimiento)
  && !idsObrasCerradas.has(movimiento.proyecto_id)
  && !accionRecortadaEnObra(user, movimiento.proyecto_id, 'GESTIONAR_MOVIMIENTO')
);

/** Error de `DELETE movimiento/:id` con el mensaje del backend y, en un 409, los pagos compartidos. */
export const errorDeBorrado = (err) => {
  const status = err?.response?.status ?? null;
  const data = err?.response?.data || {};
  const error = new Error(data.error || 'No se pudo eliminar el movimiento');
  error.status = status;
  error.pagos = status === 409 ? (data.pagos || []) : null;
  return error;
};

export const faltanDecisiones = (pagos = [], decisiones = {}) => (
  pagos.some((p) => !DECISIONES.includes(decisiones[p.pagoId]))
);
